module.exports = __webpack_public_path__ + "static/media/white-element-with-shadow.715d07ad.png";